<template>
    <div class="CircularLayout">
        <div
            v-for="(item, i) of items"
            :key="i"
            class="anchor"
            :style="{ transform: `rotate(${item.deg}deg) translateY(0em)` }"
        >
            <slot :index="i" />
        </div>
    </div>
</template>

<translations>
</translations>

<script>
export default {
    props: {
        steps: {
            type: Number,
            default: 20
        },
        progress: {
            type: Number,
            default: 0
        },
        start: {
            type: Number,
            default: 0
        },
        end: {
            type: Number,
            default: 180
        }
    },
    computed: {
        items() {
            const items = [];
            const angle = (this.end - this.start) / (this.steps - 1);
            let rot = this.start - 180;
            for (let i = 0; i < this.steps; i++) {
                items.push({
                    deg: rot
                });
                rot += angle;
            }
            return items;
        }
    }
};
</script>

<style lang="scss" scoped>
.CircularLayout {
    position: relative;
}
.anchor {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0; //2px;
    height: 0; //4em;
    transform-origin: center top;
}
</style>
